export default {
  websiteBaseUrl: 'https://dev.roomvu.com',
  apiBaseUrl: 'https://dev.roomvu.com/api',
  dashboardBaseUrl: 'https://dev.roomvu.com/dashboard',
  useProxyForApiCall: false,
  auth: {
    loginUrl: 'https://dev.roomvu.com/login',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'staging',
  },
};
